import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/KASApi";
import store from "../../../../Frontends/Common/store";

export class KASService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editKAS", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editKAS");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getKASs", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getKAS", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createKAS", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteKAS", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editKAS", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
